<app-reports [renderTemplatePDF]="true"></app-reports>
